import React, { useState, useRef, useContext } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';
import { FileUpload } from 'primereact/fileupload';
import { Toolbar } from 'primereact/toolbar';
import { Toast } from 'primereact/toast';
import AuthContext from "../context/AuthContext";
import { db_firestore } from "../firebase-configure";
import { doc, setDoc } from "firebase/firestore";

export const DatosPersonales = () => {

    
    const toast = useRef(null);
    const { currentUser, myUser, getUser } = useContext(AuthContext);
    const [form, setForm] = useState({fullname:(myUser.nam===undefined)?'':myUser.nam, telefono:(myUser.tel===undefined)?'':myUser.tel, domicilio:(myUser.dom===undefined)?'':myUser.dom, email:myUser.email});
    const chooseOptions = {label: 'Seleccionar', icon: 'pi pi-fw pi-plus'};
    const uploadOptions = {label: 'Subir', icon: 'pi pi-upload', className: 'p-button-success'};
    const cancelOptions = {label: 'Cancelar', icon: 'pi pi-times', className: 'p-button-danger'};


    const onUpload = () => {
        toast.current.show({ severity: 'info', summary: 'Subió correctamente', detail: 'Archivo a subir', life: 3000 });
    }

    const showGraboOk = (myError) => {
        toast.current.show({ severity: 'info', summary: 'Info', detail: 'La grabación fue Exitosa!', life: 3500 });
      };

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                <Button label="Grabar" icon="pi pi-save" className="p-button-primary" onClick={handleGrabar} />
            </React.Fragment>
        )
    }

    const handleGrabar = (e) => {
        e.preventDefault();
        
        const setUsuario = async () => {
            await setDoc(doc(db_firestore, "users",  currentUser.uid), {
                nam: form.fullname,
                tel: form.telefono,
                dom: form.domicilio,
            }, { merge: true });
            getUser(currentUser);
            showGraboOk();
        }

        try{
            setUsuario();

        }
        catch (error) {
            console.log(error);
        }

        // const docRef = doc(db_firestore, "users", u.user.uid);
        // const docSnap = await getDoc(docRef);
        // if (docSnap.exists()) {
        //     setMyUser(docSnap.data());
        // }
    };


    const handleChange = (e) =>{
        setForm({
            ...form,[e.target.name]:e.target.value,
        });
    };
    
    return (
        <div className="p-grid">
            
            <div className="p-col-12 p-md-12">
                <div className="card p-fluid">
                    <Toast ref={toast} />
                    <Toolbar className="p-mb-4"  right={rightToolbarTemplate}></Toolbar>

                    <h5>Datos personales</h5>
                        <div className="p-field">
                            <label htmlFor="fullName">Nombre</label>
                            <InputText id="fullName" type="text" name= "fullname" defaultValue= {form.fullname} onChange={handleChange}/>
                        </div>
                        <div className="p-field">
                            <label htmlFor="email">Email</label>
                            <InputText id="email" type="text"  defaultValue= {form.email} disabled/>
                        </div>
                        <div className="p-field">
                            <label htmlFor="domicilio">Domicilio</label>
                            <InputText id="domicilio" type="text" name= "domicilio" defaultValue = {form.domicilio} onChange={handleChange}/>
                        </div>
                        <div className="p-field">
                            <label htmlFor="telefono">Teléfono</label>
                            <InputText id="telefono" type="text" name="telefono" defaultValue = {form.telefono} onChange={handleChange}/>
                        </div>
                    
                        <h6>Imagen</h6>
                        <FileUpload name="demo" url="gs://portal-plastiandino.appspot.com/fotos/" chooseOptions={chooseOptions} uploadOptions={uploadOptions} cancelOptions={cancelOptions} onUpload={onUpload} multiple accept="image/*" maxFileSize={2000000} /> 
                        
{/*     
                        {/* <h5>Horizontal</h5>
                        <div className="p-field p-grid">
                            <label htmlFor="name3" className="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Name</label>
                            <div className="p-col-12 p-md-10">
                                <InputText id="name3" type="text" />
                            </div>
                        </div>
                        <div className="p-field p-grid">
                            <label htmlFor="email3" className="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Email</label>
                            <div className="p-col-12 p-md-10">
                                <InputText id="email3" type="text" />
                            </div>
                        </div> */}
                    </div>

                    {/* <div className="card">
                        <h5>Inline</h5>
                        <div className="p-formgroup-inline">
                            <div className="p-field">
                                <label htmlFor="firstname1" className="p-sr-only">Firstname</label>
                                <InputText id="firstname1" type="text" placeholder="Firstname" />
                            </div>
                            <div className="p-field">
                                <label htmlFor="lastname1" className="p-sr-only">Lastname</label>
                                <InputText id="lastname1" type="text" placeholder="Lastname" />
                            </div>
                            <Button label="Submit"></Button>
                        </div>
                    </div>

                    <div className="card">
                        <h5>Help Text</h5>
                        <div className="p-field p-fluid">
                            <label htmlFor="username">Username</label>
                            <InputText id="username" type="text" />
                            <small>Enter your username to reset your password.</small>
                        </div>
                    </div> */}
            </div>

            {/* <div className="p-col-12">
                <div className="card">
                    <h5>Datos personales</h5>
                    <div className="p-fluid p-formgrid p-grid">
                        <div className="p-field p-col-12 p-md-6">
                            <label htmlFor="firstname2">Nombre</label>
                            <InputText id="firstname2" type="text" />
                        </div>
                        <div className="p-field p-col-12 p-md-6">
                            <label htmlFor="lastname2">Apellido</label>
                            <InputText id="lastname2" type="text" />
                        </div>
                        <div className="p-field p-col-12">
                            <label htmlFor="address">Dirección</label>
                            <InputTextarea id="address" rows="4" />
                        </div>
                        <div className="p-field p-col-12 p-md-6">
                            <label htmlFor="city">City</label>
                            <InputText id="city" type="text" />
                        </div>
                        <div className="p-field p-col-12 p-md-3">
                            <label htmlFor="state">State</label>
                            <Dropdown id="state" value={dropdownItem} onChange={(e) => setDropdownItem(e.value)} options={dropdownItems} optionLabel="name" placeholder="Select One"></Dropdown>
                        </div>
                        <div className="p-field p-col-12 p-md-3">
                            <label htmlFor="zip">Teléfono</label>
                            <InputText id="zip" type="text" />
                        </div>
                    </div>
                </div>
            </div> */}
        </div>
    )
}



